"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Chart = void 0;
var react_1 = __importStar(require("react"));
var prop_types_1 = __importDefault(require("prop-types"));
var chart_js_1 = __importDefault(require("chart.js"));
var Chart = function (_a) {
    var id = _a.id, width = _a.width, height = _a.height, settings = _a.settings;
    react_1.useEffect(function () {
        var ctx = document.getElementById(id).getContext('2d');
        var chart = new chart_js_1.default(ctx, settings);
    }, []);
    return react_1.default.createElement("canvas", { id: id, width: width, height: height, className: 'storybook-graphs-chart' });
};
exports.Chart = Chart;
exports.Chart.propTypes = {
    /**
     * The Id of the Chart
     */
    id: prop_types_1.default.string.isRequired,
    /**
     * The Width of the Chart
     */
    width: prop_types_1.default.string,
    /**
     * The Height of the Chart
     */
    height: prop_types_1.default.string,
    /**
     * The settings of the Chart
     */
    settings: prop_types_1.default.object.isRequired
};
exports.Chart.defaultProps = {
    width: '1100',
    height: '400'
};
